import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import { Loader2 } from 'lucide-react';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Composant de protection des routes admin
 * - Redirige vers /auth/admin-login si non authentifié
 * - Redirige vers / si authentifié mais non-admin
 * - Affiche un spinner pendant le chargement
 */
export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isLoading: adminLoading } = useIsAdmin();
  const { locale } = useParams();
  const currentLocale = locale || 'fr';

  // Afficher spinner pendant le chargement
  if (authLoading || adminLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-aspexit-green mx-auto mb-2" />
          <p className="text-sm text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Rediriger vers login si non authentifié
  if (!user) {
    return <Navigate to={`/${currentLocale}/auth/admin-login`} replace />;
  }

  // Rediriger vers home si non-admin
  if (!isAdmin) {
    return <Navigate to={`/${currentLocale}`} replace />;
  }

  // Utilisateur admin authentifié : afficher le contenu
  return <>{children}</>;
}
